import { GeneratorCommitUI } from '@/components/Generator/GeneratorCommit/GeneratorCommitUI'
import { Popup } from '@/components/Popup/Popup'
import { Select } from '@/components/Select/Select'
import { TextArea } from '@/components/TextArea/TextArea'
import { postTypes } from 'functions/_utils/presets'
import { tonesPresets } from 'functions/_utils/tones'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const GeneratorFormUI: FunctionalComponent<{
  commits: string[]
  toneId: number
  setToneId: (value: number) => void
  postType: number
  setPostType: (value: number) => void
  onRemove: (commit: string) => void
}> = (props) => {
  return (
    <>
      <Popup.Fields>
        <Popup.Field label='Tone of voice'>
          <Select
            placeholder='Select tone of voice'
            onChange={props.setToneId}
            value={props.toneId}
            options={tonesPresets.map((item) => ({
              value: item.id,
              label: item.name,
            }))}
          />
        </Popup.Field>

        <Popup.Field label='Post type'>
          <Select
            placeholder='Select post type'
            value={props.postType}
            onChange={props.setPostType}
            options={postTypes.map(postType => ({
              value: postType.id,
              label: postType.name,
            }))}
          />
        </Popup.Field>

        {props.commits.length > 0
          ? (
            <Popup.Field label='Commits'>
              <div class={styles.list}>
                {props.commits.map((item) => (
                  <GeneratorCommitUI
                    onRemove={() => {
                      props.onRemove(item)
                    }}
                    commit={item}
                  />
                ))}
              </div>
            </Popup.Field>
          )
          : (
            <Popup.Field label='Context'>
              <TextArea
                placeholder={postTypes.find((item) => item.id === props.postType)
                  ?.placeholder ?? ''}
              />
            </Popup.Field>
          )}
      </Popup.Fields>
    </>
  )
}
